import React, { useEffect } from 'react';
import HeaderButton from '../HeaderButton';
import SearchComponent from './SearchComponent';
import './styles.scss';
import { useDispatch } from 'react-redux';
import { resetSearch } from 'store/slices/SearchSlice';
import { useLocation } from 'react-router-dom';

const Search = () => {
    const [isOpen, setOpen] = React.useState(false);
    const dispatch = useDispatch();

    const onToggleSearch = () => {
        setOpen(!isOpen);
        if (isOpen === false) {
            dispatch(resetSearch());
        }
    };
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
        dispatch(resetSearch());
    }, [dispatch, location]);

    return (
        <div className="search-container">
            <HeaderButton iconName={isOpen ? 'close' : 'search'} onClick={onToggleSearch} />
            {isOpen && (
                <div className={`search-dropdown ${isOpen ? 'opened' : ''}`}>
                    <SearchComponent />
                </div>
            )}
        </div>
    );
};

export default Search;
